import { CommonHelperFunctions, ILogDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class LogService {
  public static async GetFilterOptions(): Promise<AxiosResponse> {
    try {
      return await Axios.get<string, AxiosResponse>(`${backendUrl}/logs/filteroptions`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetLogsByFilter(filterObj: any): Promise<AxiosResponse> {
    try {
      return await Axios.post<string, AxiosResponse>(`${backendUrl}/logs/filter`, filterObj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Log(logObj: ILogDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<string, AxiosResponse>(`${backendUrl}/logs/create`, logObj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
